import { render, staticRenderFns } from "./gender-icon.vue?vue&type=template&id=3500ada7&lang=pug"
import script from "./gender-icon.vue?vue&type=script&lang=coffee"
export * from "./gender-icon.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports